<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="800">
    <app-feedback ref="feedback" @new-comment="onNewComment" @input="$emit('input', $event)" />
  </v-dialog>
</template>
<script>
import Feedback from "./Feedback.vue";

export default {
  components: {
    appFeedback: Feedback,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    onNewComment($event) {
      this.$emit("new-comment", $event);
      this.$emit("input", false);
    },
  },
  watch: {
    value(val) {
      if (!val && this.$refs.feedback) {
        this.$refs.feedback.reset();
      }
    },
  },
};
</script>
